import { render, staticRenderFns } from "./SharedProofPreview.vue?vue&type=template&id=03d53d0c&scoped=true"
import script from "./SharedProofPreview.vue?vue&type=script&lang=js"
export * from "./SharedProofPreview.vue?vue&type=script&lang=js"
import style0 from "./SharedProofPreview.vue?vue&type=style&index=0&id=03d53d0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d53d0c",
  null
  
)

export default component.exports